var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("h3", [_vm._v(_vm._s(this.formTitle))])
          ]),
          _vm._v(" "),
          _vm.user
            ? _c(
                "el-form",
                {
                  ref: "user",
                  attrs: {
                    model: _vm.user,
                    "label-width": "300px",
                    "label-position": "left",
                    rules: _vm.rules
                  }
                },
                [
                  _vm.user_is_admin
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "Rolle", prop: "role_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "Select User Role" },
                              model: {
                                value: _vm.user.role_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.user, "role_id", $$v)
                                },
                                expression: "user.role_id"
                              }
                            },
                            _vm._l(_vm.get_roles, function(role) {
                              return _c("el-option", {
                                key: role.id,
                                attrs: { label: role.name, value: role.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user_is_admin
                    ? _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.user.role_id && _vm.user.role_id !== 1,
                              expression: "user.role_id && user.role_id !== 1"
                            }
                          ],
                          attrs: { label: "Supplier", prop: "supplier_id" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "Supplier auswählen",
                                remote: "",
                                "default-first-option": ""
                              },
                              model: {
                                value: _vm.user.supplier_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.user, "supplier_id", $$v)
                                },
                                expression: "user.supplier_id"
                              }
                            },
                            _vm._l(_vm.get_suppliers, function(supplier) {
                              return _c("el-option", {
                                key: supplier.id,
                                attrs: {
                                  label: supplier.supplier_name,
                                  value: supplier.id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Name", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.user.name,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "name", $$v)
                          },
                          expression: "user.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "E-mail", prop: "email" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.user.email,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "email", $$v)
                          },
                          expression: "user.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Passwort", prop: "password" } },
                    [
                      _c("el-input", {
                        attrs: { type: "password" },
                        model: {
                          value: _vm.user.password,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "password", $$v)
                          },
                          expression: "user.password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Passwort wiederholen",
                        prop: "repeat_password"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "password" },
                        model: {
                          value: _vm.user.repeat_password,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "repeat_password", $$v)
                          },
                          expression: "user.repeat_password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.loading },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("user")
                            }
                          }
                        },
                        [_vm._v("Speichern")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$emit("close")
                            }
                          }
                        },
                        [_vm._v("Abbrechen")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c46fe9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c46fe9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/UserForm.vue
// module id = null
// module chunks = 